import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/ServiceDetailPage.css';

const LimpiezaPage = () => {
  const subServices = [
    {
      title: 'Limpieza Corporativa',
      description: 'Mantenimiento integral de oficinas, edificios corporativos y espacios de trabajo con los más altos estándares de calidad.',
      features: [
        'Limpieza diaria de oficinas y áreas comunes',
        'Mantenimiento de pisos y superficies',
        'Limpieza de ventanas y fachadas',
        'Desinfección de áreas de trabajo',
        'Gestión de residuos corporativos'
      ]
    },
    {
      title: 'Limpieza Hospitalaria',
      description: 'Servicios especializados para clínicas y centros de salud con protocolos certificados de bioseguridad.',
      features: [
        'Protocolos de bioseguridad certificados',
        'Desinfección profunda de áreas críticas',
        'Manejo especializado de residuos hospitalarios',
        'Personal capacitado en normativas sanitarias',
        'Equipos y productos de grado médico'
      ]
    },
    {
      title: 'Limpieza Industrial',
      description: 'Soluciones para plantas industriales, almacenes y centros de producción con equipamiento especializado.',
      features: [
        'Limpieza de naves industriales',
        'Mantenimiento de almacenes y depósitos',
        'Limpieza de maquinaria y equipos',
        'Gestión de residuos industriales',
        'Servicios de alta presión y vapor'
      ]
    },
    {
      title: 'Limpieza Educativa',
      description: 'Mantenimiento de instituciones educativas con productos seguros y ambientes saludables para el aprendizaje.',
      features: [
        'Limpieza de aulas y espacios educativos',
        'Productos seguros para niños',
        'Desinfección de áreas comunes',
        'Mantenimiento de áreas deportivas',
        'Servicios durante vacaciones escolares'
      ]
    },
    {
      title: 'Limpieza Hotelera',
      description: 'Servicios premium para hoteles y centros de hospedaje con estándares de calidad internacional.',
      features: [
        'Limpieza de habitaciones y suites',
        'Mantenimiento de áreas comunes',
        'Servicios de lavandería',
        'Limpieza de restaurantes y cocinas',
        'Atención 24/7'
      ]
    },
    {
      title: 'Limpieza Post-Construcción',
      description: 'Limpieza profunda después de obras y remodelaciones, dejando espacios listos para su uso.',
      features: [
        'Eliminación de escombros y residuos',
        'Limpieza profunda de superficies',
        'Pulido y tratamiento de pisos',
        'Limpieza de ventanas y fachadas',
        'Retiro de etiquetas y protecciones'
      ]
    }
  ];

  return (
    <div className="service-detail-page">
      <section className="service-hero">
        <div className="service-hero-content">
          <h1>Servicios de Limpieza Profesional</h1>
          <p>Soluciones integrales de limpieza con productos ecológicos certificados</p>
        </div>
      </section>

      <section className="service-intro">
        <div className="container">
          <div className="intro-content">
            <div className="intro-text">
              <h2>Limpieza Profesional y Ecológica</h2>
              <p>
                Nuestros servicios de limpieza están diseñados para mantener sus instalaciones impecables,
                saludables y sostenibles. Utilizamos exclusivamente productos ecológicos certificados que
                cuidan el medio ambiente y la salud de las personas.
              </p>
              <p>
                Con más de 15 años de experiencia, ofrecemos soluciones personalizadas para cada sector,
                respaldadas por personal altamente capacitado y equipamiento de última generación.
              </p>
            </div>
            <div className="intro-image">
              {/* Espacio para imagen principal */}
              <img
                src="/images/limpieza-principal.jpeg"
                alt="Servicios de Limpieza"
                onError={(e) => {
                  e.target.src = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 400"%3E%3Crect fill="%230D3B66" width="500" height="400"/%3E%3Ctext x="50%25" y="50%25" text-anchor="middle" dy=".3em" fill="white" font-size="80"%3E🧹%3C/text%3E%3C/svg%3E';
                }}
              />
            </div>
          </div>
        </div>
      </section>

      <section className="sub-services">
        <div className="container">
          <h2>Nuestros Servicios de Limpieza</h2>
          <div className="sub-services-grid">
            {subServices.map((service, index) => (
              <div key={index} className="sub-service-card">
                <h3>{service.title}</h3>
                <p>{service.description}</p>
                <ul>
                  {service.features.map((feature, idx) => (
                    <li key={idx}>{feature}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="service-benefits">
        <div className="container">
          <h2>¿Por Qué Elegir Nuestros Servicios de Limpieza?</h2>
          <div className="benefits-grid">
            <div className="benefit-item">
              <div className="benefit-icon">🌱</div>
              <h3>100% Ecológico</h3>
              <p>Productos biodegradables certificados que cuidan el medio ambiente</p>
            </div>
            <div className="benefit-item">
              <div className="benefit-icon">👥</div>
              <h3>Personal Certificado</h3>
              <p>Equipo capacitado y con experiencia en cada sector</p>
            </div>
            <div className="benefit-item">
              <div className="benefit-icon">⚡</div>
              <h3>Equipamiento Avanzado</h3>
              <p>Tecnología de última generación para mejores resultados</p>
            </div>
            <div className="benefit-item">
              <div className="benefit-icon">📋</div>
              <h3>Planes Personalizados</h3>
              <p>Soluciones adaptadas a sus necesidades específicas</p>
            </div>
          </div>
        </div>
      </section>

      <section className="service-cta">
        <div className="container">
          <h2>¿Listo para transformar sus espacios?</h2>
          <p>Solicite una cotización gratuita y descubra cómo podemos ayudarle</p>
          <div className="cta-buttons">
            <Link to="/contacto" className="btn-primary">Solicitar Cotización</Link>
            <Link to="/servicios" className="btn-secondary">Ver Todos los Servicios</Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default LimpiezaPage;
